const getCount = (value) => {
  if (!value) return 0
  if (value instanceof FileList) return value.length
  if (Array.isArray(value)) return value.length
  return 1
}

export default getCount
